import { FC, useCallback, useEffect, useState } from "react";

interface LineConnectorProps {
    offset: [number, number];
    parentHeight: number;
    sourceId: string;
    targetId: string;
    updateFlag: boolean;
}

const LineConnector: FC<LineConnectorProps> = ({
    offset,
    parentHeight,
    sourceId,
    targetId,
    updateFlag,
}) => {
    const [lineCoordinates, setLineCoordinates] = useState({
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
    });
    const [currentHeight, setCurrentHeight] = useState<number>();

    const updateLineCoordinates = useCallback(() => {
        const sourceElement = document.getElementById(sourceId);
        const targetElement = document.getElementById(targetId);

        if (!sourceElement || !targetElement) return;

        const sourceRect = sourceElement.getBoundingClientRect();
        const targetRect = targetElement.getBoundingClientRect();

        const sourceCenterX = sourceRect.left + sourceRect.width / 2 + offset[0];
        const sourceCenterY = sourceRect.top + sourceRect.height / 2 + offset[1];
        const targetCenterX = targetRect.left + targetRect.width / 2 + offset[0];
        const targetCenterY = targetRect.top + targetRect.height / 2 + offset[1];

        setLineCoordinates(prev => {
            if (prev.x1 === sourceCenterX && prev.y1 === sourceCenterY &&
                prev.x2 === targetCenterX && prev.y2 === targetCenterY) {
                return prev;
            }
            return {
                x1: sourceCenterX,
                y1: sourceCenterY,
                x2: targetCenterX,
                y2: targetCenterY
            };
        });
    }, [sourceId, targetId, offset])

    useEffect(() => {
        if (parentHeight > 0) {
            setCurrentHeight(parentHeight);
        }

        const sourceElement = document.getElementById(sourceId);
        const targetElement = document.getElementById(targetId);

        const resizeObserver = new ResizeObserver(updateLineCoordinates);

        if (sourceElement) resizeObserver.observe(sourceElement);
        if (targetElement) resizeObserver.observe(targetElement);

        updateLineCoordinates();

        window.addEventListener("resize", updateLineCoordinates);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", updateLineCoordinates);
        };
    }, [
        parentHeight, 
        sourceId, 
        targetId, 
        updateFlag, 
        offset, 
        updateLineCoordinates
    ]);

    return (
        <div
            id="line-container"
            style={{
                position: "absolute",
                top: "0px",
                left: "0px",
                pointerEvents: "none",
            }}
        >
            <svg className="line-svg" width="300px" height={currentHeight}>
                <line
                    id="connector-line"
                    stroke="#E1E7EA"
                    strokeWidth="2"
                    x1={lineCoordinates.x1}
                    y1={lineCoordinates.y1}
                    x2={lineCoordinates.x1}
                    y2={lineCoordinates.y2}
                />
                <line
                    id="connector-line"
                    stroke="#E1E7EA"
                    strokeWidth="2"
                    x1={lineCoordinates.x1}
                    y1={lineCoordinates.y2}
                    x2={lineCoordinates.x2}
                    y2={lineCoordinates.y2}
                />
            </svg>
        </div>
    );
};

export default LineConnector;
